import { render } from "./AttendanceConfiguration.vue?vue&type=template&id=77c6da4e&scoped=true"
import script from "./AttendanceConfiguration.vue?vue&type=script&lang=js"
export * from "./AttendanceConfiguration.vue?vue&type=script&lang=js"

import "./AttendanceConfiguration.vue?vue&type=style&index=0&id=77c6da4e&lang=scss&scoped=true"

import exportComponent from "../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c6da4e"]])

export default __exports__